import React from 'react';
import { TitleBarAndMenu } from './TitleBarAndMenu';

export const GridLayoutForLeftTabbedContent = (props) => (
    <div>
        <TitleBarAndMenu {...props} />
        <div className='grid-x'>
            <div className='cell medium-12 large-12'>
                {props.children}
            </div>
            <div className='' id='right-content'>
            </div>
        </div>
    </div>
);
